import { ApplicationName, AppTheme, DialogConfig } from '@performance/ui'
import { DialogApplication } from '@shared/dialogs/dialog-application/dialog-application'
import { DialogType } from '@shared/dialogs/dialog-application/dialog-application.models'
import { Profile } from '@domains/profile'

export const buildAppDialogConfig = (
  application: ApplicationName,
  userProfile: Profile,
): DialogConfig => ({
  content: {
    component: DialogApplication,
  },
  overlay: {
    panelClass: ['mcp-dialog-app-launcher', AppTheme.Dark],
    data: {
      type: DialogType.Download,
      application,
      userProfile,
    },
  },
})
